module.exports = __webpack_public_path__ + "static/media/upload.172ad4ee.svg";